
import React from 'react';
import { CheckCircle, AlertTriangle } from 'lucide-react';

interface StatusMessageProps {
  type: 'success' | 'error';
  message: string;
}

const StatusMessage: React.FC<StatusMessageProps> = ({ type, message }) => {
  const isSuccess = type === 'success';
  
  return (
    <div className={`flex items-center gap-2 p-3 border rounded-lg ${
      isSuccess 
        ? 'bg-green-50 border-green-200' 
        : 'bg-red-50 border-red-200'
    }`}>
      {isSuccess ? (
        <CheckCircle className="w-4 h-4 text-green-500 flex-shrink-0" />
      ) : (
        <AlertTriangle className="w-4 h-4 text-red-500 flex-shrink-0" />
      )}
      <p className={`text-sm ${
        isSuccess ? 'text-green-700' : 'text-red-700'
      }`}>
        {message}
      </p>
    </div>
  );
};

export default StatusMessage;
